import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import mask from '@alpinejs/mask'
import persist from '@alpinejs/persist'

/**
 * Alpine, already set up.
 *
 * Every other admin module imports Alpine from here rather than from 'alpinejs'
 * directly, and that is the whole point of this file existing.
 *
 * A plugin adds its magics when `Alpine.plugin()` runs - `$persist` does not exist
 * before then. ES imports are hoisted and run before the body of the module that
 * imports them, so registering the plugins in the entry file put them *after* every
 * module that uses them. `stores.js` called `Alpine.$persist(false)` at its top level,
 * got `undefined`, and threw - which aborted the entry module before `Alpine.start()`
 * was ever reached.
 *
 * The admin has no working JavaScript at all when that happens: no modals, no
 * dropdowns, no checkboxes, no search box filled in from the URL. Nothing in the page
 * says why, because the script loaded and returned 200; it simply stopped on its
 * first line of real work.
 *
 * Putting the setup in a module of its own makes the order a fact about the import
 * graph rather than a line somebody has to keep at the top of a file.
 */
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(mask)
Alpine.plugin(persist)

export default Alpine
